import React from "react";
import RecentItem from "../recent-summary/parts/RecentItem";
import RecentSummary from "../recent-summary/RecentSummary";
import iconPdf from "../../assets/images/dummy/icon-pdf.png";
import { IconDownload } from "../../icons/Icon";

const title = "Manuales recientes";
const badgeColor = "#B5E4CA";

const RecentManuals = ({ manuals, download, downloading }) => {
  return (
    <RecentSummary
      title={title}
      badgeColor={badgeColor}
      noData={!manuals.length}
    >
      {manuals.map((manual) => (
        <RecentItem
          key={manual.id}
          icon={iconPdf}
          primaryInfo={manual.filename}
          controlIcon={<IconDownload color="#33383F" />}
          control={() => download("manuals", manual.id)}
          loading={downloading == manual.id}
        />
      ))}
    </RecentSummary>
  );
};

export default RecentManuals;
